<template>
  <div class="dropdown-item">
    <div class="dropdown-container">
      <slot />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dropdown-item
  @apply text-[#{$global-t-tertiary}]
  @apply text-size-sm t-menu-sm
  @apply flex w-full h-[20px]
  @apply px-[10px]
  @apply bg-[#{$menu-bg-footer}]
.dropdown-container
  @apply gap-[#{$menu-context-gap-status}]
  @apply flex flex-grow items-center w-full
</style>
